import React from "react"
import { Paper, styled } from "@mui/material";

const StyledHeader = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.h1,
    display: 'flex',
    color: theme.palette.text.primary,
    boxShadow: 'none',
    justifyContent: 'center',
    fontSize: '40px',
    paddingBottom: '40px'
}));

const Headers = (props) => {
  const { title } = props

  return (
    <StyledHeader component="h1">{title}</StyledHeader>
  );
}

export default Headers
